import { FloorplanContainer } from "@/components/floorplans/FloorplanContainer";
import { AppointmentsContainer } from "@/components/appointments/AppointmentsContainer";
function isValidAppType(appType) {
    return Object.keys(appRegistry).includes(appType);
}
export var appRegistry = {
    "floorplan-grid": FloorplanContainer,
    "appointments": AppointmentsContainer,
};
export var getAppComponent = function (appType) {
    if (!isValidAppType(appType)) {
        console.warn("Harmony: Invalid app type", appType);
        return null;
    }
    return appRegistry[appType] || null;
};
